export const setColumns = ({ columns, section }) => state => {
  return {
    ...state,
    [section]: {
      ...state[section],
      columns,
    },
  };
};
